(function($, App, Utils, Components) {
  'use strict';

  var logger = new Logger('DataModals');

  Components.create('DataModals', {
    Selectors: {
      main: '*[data-modal], *[data-modal-inside] a'
    },

    defaultOptions: {
      showCloseButton: true,
      escapeButtonCloses: true,
      overlayClosesOnClick: true,
      appendLocation: 'body',
      className: 'vex-theme-default',
      overlayClassName: '',
      contentClassName: '',
      closeClassName: '',
      closeAllOnPopState: true,

      // == Each callback is called with the context of the vex instance.
      // == That is, the keyword this inside of these callback functions references the vex instance.

      // is called immediately after the vex instance is appended to the DOM
      afterOpen: function() {
        Components.trigger('modal:afterOpen', [this]);
        let $gallery = $(this.contentEl).find('.gallery-modal');
        if ($gallery) {
          $gallery.addClass('carousel');
          Components.Carousels.bindSingleCarousel($gallery);
        }

				$.each( $(Components.DataModals.Selectors.main), function() {
					let opts = Utils.jsonDA($(this), 'modal')
	        if (opts.event && opts.event.on.open) {
	          document.dispatchEvent(new CustomEvent(opts.event.on.open, {}));
	        }
				});

      },

      // is called immediately after the vex instance is removed from the DOM
      afterClose: function() {
        Components.trigger('modal:afterClose', [this]);
        let $gallery = $(this.contentEl).find('.gallery-modal');
        if ($gallery) {
          Components.Carousels.destroySingleCarousel($gallery);
        }
      },

      // is called before removing the instance from the DOM, and should return
      // a boolean. If beforeClose returns false, the close will not go through
      // and the vex instance will remain open. Useful for validation or any
      // other checks you need to perform.
      beforeClose: function() {
        Components.trigger('modal:beforeClose', [this]);
      }
    },

    bindCustomEvents: function() {
      Components.on('modal:open', function(e, html, mainClass) {
        Components.DataModals.open({
          content: $(html),
          className: mainClass
        });
      });

      Components.on("overlays:close modal:close", function() {
        vex.closeAll();
      });
    },

    bindEvents: function() {
      App.Body.on('click.modal', Components.DataModals.Selectors.main, function(e) {
        e && e.preventDefault();

        var self = $(this),
          opts = Utils.jsonDA(self, 'modal'),
          contentSelector = opts.static,
          inside = opts.inside;

        if (!self.data('modalStatus')) {
          self.data('modalStatus', 'opening');

          opts.afterClose = function() {
            self.removeData('modalStatus');
          };

          if (contentSelector) {
            Components.DataModals.open(opts);
            self.removeData('modalStatus');

          } else if (inside) {
            opts['static'] = inside;
            Components.DataModals.open(opts);
            self.removeData('modalStatus');
          } else {
            // open remote content
            Components.DataModals.getRemoteContent(self, opts);
          }

          if(self.data('modal-only-once')) {
            self.attr('data-modal-status', 'closed');
          }

        }
      });

      Components.on('modal:remote', function(e, element) {
        Components.DataModals.getRemoteContent(element, element.data());
      });

      Components.on('modal:alert', (e, data) => {
        Components.DataModals.open(data);
      });
    },

    getRemoteContent: function($this, opts) {
      var url = typeof $this == 'string' ? $this : $this.prop('href') || $this.data('modal');
      opts = typeof opts == 'string' ? {} : opts || {};

      $.ajax({
        url: url,
        dataType: 'html',
        data: {
          format: 'ajax'
        }
      }).done(function(data) {
        logger.d('Remote modal call successful.');
        opts.unsafeContent = data;
        Components.DataModals.open(opts);
      }).fail(function(){
        self.removeData('modalStatus');
      });
    },

    getOpts: function(opts) {
      if (opts.afterOpen) {
        opts.callback = opts.afterOpen;
        delete opts['afterOpen'];
      }

      if (opts.callback) {
        opts.afterOpen = function() {
          Components.DataModals.defaultOptions.afterOpen.apply(this);
          if (typeof opts.callback == 'string') {
            Utils.executeFunctionByName(opts.callback, window, this);
          } else if (typeof opts.callback == 'function') {
            opts.callback(this);
          }
        };
      }

      /*if (opts.afterClose) {
        opts.afterClose = function() {
          Components.DataModals.defaultOptions.afterClose.apply(this);
          if (typeof opts.afterClose == 'string') {
            Utils.executeFunctionByName(opts.afterClose, window, this);
          } else if (typeof opts.afterClose == 'function') {
            opts.afterClose(this);
          }
        };
      }*/

      if (opts.beforeClose) {
        opts.beforeClose = function() {
          Components.DataModals.defaultOptions.beforeClose.apply(this);
          if (typeof opts.beforeClose == 'string') {
            Utils.executeFunctionByName(opts.beforeClose, window, this);
          } else if (typeof opts.beforeClose == 'function') {
            opts.beforeClose(this);
          }
        };
      }

      if (opts.className) {
        opts.className += ' ' + Components.DataModals.defaultOptions.className;
      }

      if (opts.static) {
        var $content = $(opts.static);
        if ($content.length == 1) {
          // open static content
          opts.unsafeContent = $content.html();
        } else {
          logger.warn("Asked for static content but '%s' selctor is empty or returned more than a result. Check your markup.", $content);
        }
      }

      var o = $.extend({}, Components.DataModals.defaultOptions, opts);

      logger.i('Opening modal:', o);

      return o;
    },

    open: function(opts) {
      vex.open(Components.DataModals.getOpts(opts));
    },

    initImmediate: function($target) {
      $target.filter('[data-modal-immediate="true"]').trigger('click');
    },

    init: function() {
      Components.DataModals.bindEvents();
      Components.DataModals.bindCustomEvents();
      Components.DataModals.initImmediate($(Components.DataModals.Selectors.main));
    }
  });
})(jQuery, window.App, window.App.Utils, window.App.Components);
